import { FC, useEffect, useState } from "react";
import { Button, Typography, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";

import { getGoogleServiceAccountEmail } from "../../../../common/api/ConfigClient";

export const GoogleShareHint: FC = () => {
    const [email, setEmail] = useState<string>();

    useEffect(() => {
        getGoogleServiceAccountEmail().then(setEmail);
    }, []);

    if (!email) return null;

    const handleCopy = () => {
        navigator.clipboard.writeText(email);
        message.success("Email copied");
    };

    return (
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            Share your document with{" "}
            <Typography.Text code style={{ fontSize: 12 }}>
                {email}
            </Typography.Text>
            <Button
                type="link"
                size="small"
                icon={<CopyOutlined />}
                onClick={handleCopy}
                style={{ padding: "0 4px" }}
            />
        </Typography.Text>
    );
};
